/* eslint-disable camelcase */
const base_url = 'https://spiral-01.herokuapp.com';

export default base_url;
